/** @jsxImportSource @emotion/react */
import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { LayersOrganizer } from '@app/components/Molecules/RiskSideDrawerContent/tabs/InformativePanel/LayersTab/LayersOrganizer'
import type { MapLayer } from '@app/types/layerTypes'
import {
  layersPreviewBody,
  layersPreviewContainer,
  layersPreviewSection,
  layersPreviewTitle,
} from './LayersPreview.styles'
import { Section } from '@app/components/Atoms/Section'
import { ModalLayer } from '@app/components/Molecules/LayersControl'
import { useFetchLegends } from '@app/hooks/useFetchLegends'

export interface DialogLayersPreviewProps {
  stagedLayers: ModalLayer[]
  handleUpdateLayers?: (newLayers: MapLayer[]) => void
  handleToggleLayerVisibility?: (layer: MapLayer) => void
}

export interface LayersPreviewProps {
  dialogProps: DialogLayersPreviewProps
  isDialogPreview?: boolean
}

export const LayersPreview = ({ dialogProps, isDialogPreview = false }: LayersPreviewProps) => {
  const theme = useTheme()
  const { data: legendsData = {} } = useFetchLegends()
  return (
    <Box css={layersPreviewContainer}>
      <Section css={layersPreviewSection}>
        <Typography variant="body1" align="center" css={layersPreviewTitle}>
          Layers Preview
        </Typography>
        <Box css={layersPreviewBody({ theme })}>
          {Object.keys(legendsData).length ? (
            <LayersOrganizer dialogProps={dialogProps} isDialogPreview={isDialogPreview} />
          ) : null}
        </Box>
      </Section>
    </Box>
  )
}
